<template>
  <div class="hk-video">
    <div
      :id="'playWind' + videoId"
      :style="{ width: VWidth + 'px', height: VHeight + 'px' }"
    ></div>
    <div class="button_box flex-space-between">
      <div>
        <span @click="stopPlay" v-if="playState"
          ><img src="@/assets/images/hk-video/play-o.png" alt=""
        /></span>
        <span @click="realplay()" v-else
          ><img src="@/assets/images/hk-video/play-c.png" alt=""
        /></span>
        <span v-show="!playBackState">
          <span @click="closeSound()" v-if="audioState"
            ><img src="@/assets/images/hk-video/audio-o.png" alt=""
          /></span>
          <span @click="openSound()" v-else
            ><img src="@/assets/images/hk-video/audio-c.png" alt=""
          /></span>
        </span>
        <span v-show="!playBackState" @click="openHolder()"
          ><img src="@/assets/images/hk-video/holder.png" alt=""
        /></span>
      </div>
      <div>
        <span @click="openTime()" v-if="playBackState"
          ><img src="@/assets/images/hk-video/date.png" alt=""
        /></span>
        <span @click="realplay()" v-if="playBackState"
          ><img src="@/assets/images/hk-video/back.png" alt=""
        /></span>
        <span @click="playbackV()" v-else
          ><img src="@/assets/images/hk-video/play-back.png" alt=""
        /></span>
        <span @click="fullSreen()"
          ><img src="@/assets/images/hk-video/full-sreen.png" alt=""
        /></span>
      </div>
      <div class="time-model" v-show="timeModelState">
        <Form :label-width="80">
          <FormItem label="开始时间">
            <DatePicker
              type="datetime"
              placeholder="请输入开始时间"
              style="width: 200px"
              v-model="startTime"
            ></DatePicker>
          </FormItem>
          <FormItem label="结束时间">
            <DatePicker
              type="datetime"
              placeholder="请输入结束时间"
              style="width: 200px"
              v-model="endTime"
            ></DatePicker>
          </FormItem>
          <div class="flex-space-around" style="margin-top: 10px;">
            <Button @click="timeBtn(1)">取消</Button>
            <Button
              @click="timeBtn(2)"
              type="primary"
              :disabled="!startTime || !endTime"
              >确定</Button
            >
          </div>
        </Form>
      </div>
      <div class="holder-model" v-show="holderState">
        <div class="top">
          <img
            class="up"
            src="@/assets/images/hk-video/up-o.png"
            alt=""
            v-show="upState"
            @click="setHolder('1', false, 'upState')"
          />
          <img
            class="up"
            src="@/assets/images/hk-video/up-c.png"
            alt=""
            v-show="!upState"
            @click="setHolder('1', true, 'upState')"
          />
          <img
            class="left"
            src="@/assets/images/hk-video/left-o.png"
            alt=""
            v-show="leftState"
            @click="setHolder('2', false, 'leftState')"
          />
          <img
            class="left"
            src="@/assets/images/hk-video/left-c.png"
            alt=""
            v-show="!leftState"
            @click="setHolder('2', true, 'leftState')"
          />
          <img
            class="down"
            src="@/assets/images/hk-video/down-o.png"
            alt=""
            v-show="downState"
            @click="setHolder('3', false, 'downState')"
          />
          <img
            class="down"
            src="@/assets/images/hk-video/down-c.png"
            alt=""
            v-show="!downState"
            @click="setHolder('3', true, 'downState')"
          />
          <img
            class="right"
            src="@/assets/images/hk-video/right-o.png"
            alt=""
            v-show="rightState"
            @click="setHolder('4', false, 'rightState')"
          />
          <img
            class="right"
            src="@/assets/images/hk-video/right-c.png"
            alt=""
            v-show="!rightState"
            @click="setHolder('4', true, 'rightState')"
          />
        </div>
        <div class="bottom flex-space-between">
          <div>
            近焦
            <img
              src="@/assets/images/hk-video/close-focus-o.png"
              alt=""
              v-show="closeFocusState"
              @click="setHolder('5', false, 'closeFocusState')"
            />
            <img
              src="@/assets/images/hk-video/close-focus-c.png"
              alt=""
              v-show="!closeFocusState"
              @click="setHolder('5', true, 'closeFocusState')"
            />
          </div>
          <div>
            远焦
            <img
              src="@/assets/images/hk-video/telephoto-o.png"
              alt=""
              v-show="telephotoState"
              @click="setHolder('6', false, 'telephotoState')"
            />
            <img
              src="@/assets/images/hk-video/telephoto-c.png"
              alt=""
              v-show="!telephotoState"
              @click="setHolder('6', true, 'telephotoState')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./dist/polyfill2.js";
import { JSPlugin } from "./dist/jsPlugin-1.2.0.min.js";
export default {
  props: {
    VWidth: {
      type: String,
      default: "600",
    },
    VHeight: {
      type: String,
      default: "400",
    },
    previewUrl: {
      type: String,
      default: "",
      // "rtsp://39.106.198.227:554/dac/realplay/2958ABC5-BBF2-E848-A5CF-C14FB27F1F7E1/SUB/TCP?streamform=rtp",
    },
    channelNum: {
      type: String,
      default: "",
    },
    sid: {
      type: String,
      default: "",
    },
    videoId: {
      type: Number,
      default: 0,
    },
  },
  name: "hk-video",
  data() {
    return {
      iWind: 0,
      jsDecoder: {},
      accessUrl: "", //access URL ws://39.106.198.227:80
      username: "", //user name admin
      password: "", //LiAn@357951
      playbackUrl: "",
      // "rtsp://39.106.198.227:554/dac/realplay/2958ABC5-BBF2-E848-A5CF-C14FB27F1F7E1/SUB/TCP?streamform=rtp",
      playState: true, //是否播放 true是 false 否
      audioState: false, // 是否开启声音 true是 false 否
      playBackState: false, //是否是回放 true是 false 否
      timeModelState: false, //显示选择时间
      holderState: false, //显示云台
      startTime: null,
      endTime: null,
      upState: false,
      leftState: false,
      downState: false,
      rightState: false,
      closeFocusState: false,
      telephotoState: false,
    };
  },
  methods: {
    initPlugin() {
      this.jsDecoder.JS_SetWindowControlCallback({
        windowEventSelect: function(iWndIndex) {
          this.iWind = iWndIndex;
          console.log(iWndIndex);
        },
        pluginErrorHandler: function(iWndIndex, iErrorCode, oError) {
          console.log(iWndIndex, iErrorCode, oError);
        },
        performanceLack: function() {
          console.log("lack of performance ");
        },
      });
    },

    realplay() {
      let _that = this;
      this.timeModelState = false;
      if (this.playbackUrl) {
        this.playbackUrl = "";
        this.stopPlay();
      }
      this.playBackState = false;
      console.log("播放地址", this.previewUrl);
      console.log("播放地址ip", this.accessUrl);
      console.log("播放地址账号", this.username);
      console.log("播放地址密码", this.password);
      this.jsDecoder
        .JS_Play(
          this.accessUrl,
          {
            playURL: this.previewUrl, //play URL,
            auth: this.username + ":" + this.password, //username:password
          },
          this.iWind
        )
        .then(
          function() {
            _that.playState = true;
            console.log("realplay success");
          },
          function() {}
        );
    },
    stopPlay() {
      let _that = this;
      this.jsDecoder.JS_Stop(this.iWind).then(function() {
        console.log("stop success");
        _that.playState = false;
      });
    },
    playbackV() {
      this.stopPlay();
      this.playBackState = true;
      this.jsDecoder
        .JS_Play(
          this.accessUrl,
          {
            playURL: this.playBackState ? this.playbackUrl : this.playbackUrl,
            auth: this.username + ":" + this.password, //username:password
          },
          this.iWind,
          " ",
          " "
        )
        .then(function() {
          console.log("playback success");
        });
    },
    openSound() {
      this.jsDecoder.JS_OpenSound(this.iWind);
      this.audioState = true;
    },

    closeSound() {
      this.jsDecoder.JS_CloseSound();
      this.audioState = false;
    },
    fullSreen() {
      console.log(this.iWind);
      // 全屏
      this.jsDecoder.JS_FullScreenDisplay(true);
      // this.jsDecoder.JS_FullScreenSingle(this.iWind);
    },
    arrangeWindow(i) {
      // 分屏
      this.jsDecoder.JS_ArrangeWindow(i);
    },
    openTime() {
      // 选择时间
      this.startTime = null;
      this.endTime = null;
      this.timeModelState = true;
      this.holderState = false;
    },
    timeBtn(type) {
      this.timeModelState = false;
      if (type === 2) {
        var data = {
          type: "post",
          url: "/mcbw/cameras/hik/stream_media",
          obj: {
            commitData: {
              id: this.channelNum,
              devIndex: this.sid,
              webType: "1",
              streamType: "sub",
              method: "playback",
              startTime: this.startTime
                ? new Date(this.startTime).getTime()
                : null,
              endTime: this.endTime ? new Date(this.endTime).getTime() : null,
            },
          },
        };
        this.$Axios(data)
          .then((res) => {
            if (res.success && res.data) {
              this.playbackUrl = res.data;
              this.playbackV();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.startTime = null;
        this.endTime = null;
      }
    },
    openHolder() {
      //打开云台
      this.holderState = !this.holderState;
      this.timeModelState = false;
    },
    setHolder(type, boolean, obj) {
      this[obj] = boolean;
      let commitData = {
        id: this.channelNum,
        devIndex: this.sid,
        tilt: 0,
        pan: 0,
        zoom: 0,
      };
      switch (type) {
        case "1": // 上转
          this.leftState = false;
          this.downState = false;
          this.rightState = false;
          this.closeFocusState = false;
          this.telephotoState = false;
          commitData.tilt = this.upState ? 50 : 0;
          commitData.pan = 0;
          commitData.zoom = 0;
          break;
        case "2": // 左转
          this.upState = false;
          this.downState = false;
          this.rightState = false;
          this.closeFocusState = false;
          this.telephotoState = false;
          commitData.pan = this.leftState ? -50 : 0;
          commitData.tilt = 0;
          commitData.zoom = 0;
          break;
        case "3": // 下转
          this.upState = false;
          this.leftState = false;
          this.rightState = false;
          this.closeFocusState = false;
          this.telephotoState = false;
          commitData.tilt = this.downState ? -50 : 0;
          commitData.pan = 0;
          commitData.zoom = 0;
          break;
        case "4": // 右转
          this.upState = false;
          this.leftState = false;
          this.downState = false;
          this.closeFocusState = false;
          this.telephotoState = false;
          commitData.pan = this.rightState ? 50 : 0;
          commitData.tilt = 0;
          commitData.zoom = 0;
          break;
        case "5": // 近焦
          this.upState = false;
          this.leftState = false;
          this.downState = false;
          this.rightState = false;
          this.telephotoState = false;
          commitData.tilt = 0;
          commitData.pan = 0;
          commitData.zoom = this.closeFocusState ? 20 : 0;
          break;
        case "6": // 远焦
          this.upState = false;
          this.leftState = false;
          this.downState = false;
          this.rightState = false;
          this.closeFocusState = false;
          commitData.tilt = 0;
          commitData.pan = 0;
          commitData.zoom = this.telephotoState ? -20 : 0;
          break;
      }
      this.cameraMotion(commitData);
    },
    cameraMotion(commitData) {
      //操控摄像头
      return new Promise((resolve, reject) => {
        var data = {
          type: "post",
          url: "/mcbw/cameras/hik/pan_tilt",
          data: { commitData },
        };
        this.$Axios(data)
          .then((res) => {
            if (res.success && res.data) {
              resolve();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDeviceUser() {
      let _that = this;
      return new Promise((resolve, reject) => {
        let commitData = {};
        var data = {
          type: "post",
          url: "/mcbw/cameras/hik/device_user",
          data: { commitData },
        };
        _that.$Axios(data)
          .then((res) => {
            if (res.data.success && res.data.data) {
              _that.accessUrl = "ws://" + res.data.data.idAddress;
              _that.username = res.data.data.userName;
              _that.password = res.data.data.password;
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject();
            console.log(err);
          });
      });
    },
  },
  mounted() {
    let _that = this;
    this.$nextTick(() => {
      _that.getDeviceUser().then((res) => {
        _that.jsDecoder = new JSPlugin({
          szId: "playWind" + _that.videoId,
          iWidth: _that.VWidth,
          iHeight: _that.VHeight,
          iMaxSplit: 1,
          iCurrentSplit: 1,
          szBasePath: "./static/dist",
          oStyle: {
            border: "#343434",
            borderSelect: "#343434",
            background: "#4C4B4B",
          },
          bOnlySupportJSDecoder: true,
        });
        _that.initPlugin();
        setTimeout(() => {
          _that.realplay();
        }, 1000);
        window.onresize = function() {
          _that.jsDecoder.JS_Resize(_that.VWidth, _that.VHeight);
        };
      });
    });
  },
  created() {},
  destroyed() {
    this.stopPlay();
  },
};
</script>

<style scoped lang="scss">
.hk-video {
  position: relative;
  margin-top: 29px;
}
.button_box {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 5px 10px;
  > div {
    display: flex;
    span {
      img {
        width: 18px;
        height: 18px;
      }
    }
    > span {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .ivu-form-item {
    margin-bottom: 5px;
  }
  .time-model {
    position: absolute;
    right: 10px;
    bottom: 40px;
    width: 300px;
    background-color: #cde1fd;
    border-radius: 6px;
    padding: 20px 0;
  }
  .holder-model {
    position: absolute;
    right: 10px;
    bottom: 40px;
    width: 120px;
    background-color: #cde1fd;
    border-radius: 6px;
    padding: 20px 0;
    .top {
      position: relative;
      height: 100px;
      img {
        cursor: pointer;
      }
      .up {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 0px;
      }
      .left {
        position: absolute;
        left: 20px;
        top: 14px;
      }
      .down {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 54px;
      }
      .right {
        position: absolute;
        right: 20px;
        top: 14px;
      }
    }
    .bottom {
      padding: 0 10px;
      img {
        width: 15px;
        cursor: pointer;
        margin-left: 2px;
        vertical-align: middle;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlay/hkVideo/hkVideo.vue